import { ref } from 'vue';

import { defineStore } from 'pinia';

const useAuthStore = defineStore('auth', () => {
  // State
  const isUserAuthenticated = ref(false);
  const pwdChangeUser = ref<unknown>(null);
  const userRoles = ref<string[]>([]);

  // Actions
  const setUserAuthenticated = (payload: boolean) =>
    (isUserAuthenticated.value = payload);
  const setPwdChangeUser = (payload: unknown) =>
    (pwdChangeUser.value = payload);
  const setUserRoles = (payload: string[]) => (userRoles.value = payload);

  return {
    isUserAuthenticated,
    pwdChangeUser,
    userRoles,
    setUserAuthenticated,
    setPwdChangeUser,
    setUserRoles
  };
});

export default useAuthStore;
